import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faStrikethrough } from '@fortawesome/pro-light-svg-icons';

export type ProLightStrikethroughProps = IconComponentProps;

export const ProLightStrikethrough = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightStrikethroughProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faStrikethrough}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faStrikethrough}
    />
  );
};

ProLightStrikethrough.displayName = 'ProLightStrikethrough';
